// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__vbdxZ","addWidgetButton":"Header_addWidgetButton__14xHY","dashboardTabs":"Header_dashboardTabs__3XI0V","active":"Header_active__33GBV"};